import zhMessages from '../locales/zh-TW.json'

const ZhLan = {
  messages: {
    ...zhMessages
  },
  locale: 'zh-TW',
}
export default ZhLan
